<template>
  <div class="dropdown">
    <button
      class="dropdown-toggle"
      type="button"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <span
        v-if="activeItem && getObjLength(activeItem)"
        v-html="activeItem.title"
      ></span>
      <span v-else v-html="header || 'Select'"></span>
      <i class="fa fa-angle-down"></i>
    </button>
    <div class="dropdown-menu dropdown-menu-right">
      <h6 class="dropdown-header" v-if="header" v-html="header"></h6>
      <div class="dropdown-divider" v-if="header"></div>
      <div
        class="dropdown-item"
        v-for="(item, i) in items"
        :key="i"
        :class="{ active: item.active, disabled: item.disabled }"
        @click.prevent="select(item)"
        role="button"
      >
        <span v-html="item.title"></span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    header: {
      type: String,
      default: null,
    },
  },
  methods: {
    select(item) {
      if (item.active) return;
      this.$emit("selected", item);
    },
  },
  computed: {
    activeItem() {
      return this.items.find((item) => item.active === true);
    },
  },
};
</script>
<style lang="scss" scoped>
.dropdown {
  .dropdown-toggle {
    color: var(--font-color);
    font-size: 0.94rem;
    font-weight: 600;
    border-radius: var(--border-radius);
    transition: var(--transition);
    border: 2px solid var(--lighter);
    background: transparent;
    padding: 0.275rem 1rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.4rem;
    &:hover,
    &:focus {
      background: var(--lighter);
      border-color: var(--lighter);
    }
    &::after {
      content: none;
    }
  }
}
</style>